import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateMembershipMutationVariables = Types.Exact<{
  input: Types.UpdateMembershipInput;
  locale?: Types.InputMaybe<Types.SupportedLocale>;
}>;


export type UpdateMembershipMutation = { __typename?: 'Mutation', updateMembership?: { __typename?: 'UpdateMembershipPayload', membership?: { __typename?: 'Membership', id: string, accountUser?: { __typename?: 'AccountUser', id: string, inviteEmailAddress?: string | null, name?: string | null } | null, accountUserGroup?: { __typename?: 'AccountUserGroup', id: string, name?: string | null } | null, userGroup?: { __typename?: 'AdobeManagedUserGroup', id: string, name?: string | null } | { __typename?: 'FrameManagedUserGroup', id: string, name?: string | null } | { __typename?: 'WorkfrontManagedUserGroup', id: string, name?: string | null } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null } | null };


export const UpdateMembership = /*#__PURE__*/ gql`
    mutation UpdateMembership($input: UpdateMembershipInput!, $locale: SupportedLocale) {
  updateMembership(input: $input) {
    membership {
      accountUser {
        id
        inviteEmailAddress
        name
      }
      accountUserGroup {
        id
        name
      }
      userGroup {
        id
        name
      }
      id
      role {
        id
        name(locale: $locale)
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateMembershipMutation, UpdateMembershipMutationVariables>;

          

          export const useUpdateMembershipMutation = (options?:MutationHookOptions<UpdateMembershipMutation, UpdateMembershipMutationVariables>) => useMutation(UpdateMembership, options);
          

          export type UpdateMembershipMutationOptions = MutationHookOptions<UpdateMembershipMutation, UpdateMembershipMutationVariables>;

          

          export type UpdateMembershipMutationResult = ReturnType<typeof useUpdateMembershipMutation>[1];

          
